<template>
  <div class="home_wrap">
    <van-row class="topSection">
      <van-col span="4" style="text-align: left">
        <img
          src="../images/common/backArrow.png"
          @click="$router.back()"
          class="imageback"
        />
      </van-col>
      <van-col span="20" style="text-align: right">
        <span style="color: #ffffff; font-size: 30px; font-weight: 700">{{
          $t("setNickName.modifyNickname")
        }}</span>
      </van-col>
    </van-row>
    <van-row>
      <div class="wrap">
        <!-- ---------- nick name ------ -->
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">
              {{ $t("setNickName.modifyNickname") }}:
            </p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon"
            ><img src="../images/register/username.png" alt=""
          /></span>
          <input type="text" v-model="nickname" />
        </div>
        <van-row>
          <van-col span="24">
            <div
              class="confirm_btn"
              :class="nickname != '' ? '' : 'no_touch'"
              @click="nickname != null ? submit() : ''"
            >
              {{ $t("setNickName.modify") }}
            </div>
          </van-col>
        </van-row>
      </div>
    </van-row>
  </div>
</template>

<script>
import Vue from "vue";
import { Row, Col } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Row).use(Col);

export default {
  name: "setnickname",
  data() {
    return {
      nickname: "",
    };
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch("/user/info").then((r) => {
        this.nickname = r.data.name;
      });
    },
    submit() {
      Fetch("/user/changeNickName", {
        nickName: this.nickname,
      })
        .then((res) => {
       
          if (res.code == 1) {
            this.$toast({
              background: "#07c160",
              message: this.$t("setNickName.success"),
            });
          } else {
            this.$toast(res.data.msg);
            return;
          }
        })
        .then(() => {
          this.$router.go(-1);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
}

.topSection {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 30px 15px 20px;
}

.imageback {
  height: 30px;
  width: auto;
}

.no_touch {
  pointer-events: none;
}

.wrap {
  border: 1px solid #ffffff;
  border-radius: 13px;
  padding: 25px 15px;
  background: #ebebeb29;
  margin: 10px;
}

.confirm_btn.no_touch {
  color: rgba(255, 255, 255, 0.5);
}

.confirm_btn {
  height: 50px;
  line-height: 46px;
  font-size: 24px;
  width: 100%;
  border-radius: 15px;
  color: #ffffff;
  text-align: center;
  border: 1px solid #ffffff;
  margin-top: 60px;
  background: linear-gradient(
    117deg,
    rgba(254, 166, 0, 1) 0%,
    rgba(255, 188, 0, 1) 100%
  );
}

.labelText {
  color: #ffffff;
  padding: 4px 10px;
  font-size: 14px;
}

.item {
  height: 46px;
  border: 1px solid #ffffff;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 9px;
  border-radius: 20px;
  background: #d4dddfde;
  .icon {
    width: 70px;
    height: 27px;
    padding-left: 10px;
    display: flex;
    align-items: center;
    img {
      width: 27px;
      height: 27px;
    }
  }
  input {
    height: 20px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
  }
}
</style>
